var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckmark = function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    width: 14,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.898 5.673a.882.882 0 0 0-1.247 0l-.085.085a.882.882 0 0 0 0 1.248l2.708 2.708v.001l1.332 1.333L5.94 9.714l7.373-7.374a.882.882 0 0 0 0-1.248l-.085-.085a.882.882 0 0 0-1.248 0l-6.75 6.75a.882.882 0 0 1-1.247 0L1.898 5.673Z",
    fill: "currentColor"
  })));
};
export default SvgIconCheckmark;